var minBy = {};
export {
  minBy as __exports
};
//# sourceMappingURL=minBy2.js.map
